<template>
  <div>
    <component :is="alertsComponent" v-bind="$attrs" v-on="$listeners" :interval="global && interval" :icon="(!global && customIconSrc) ? customIconSrc : ''">
      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope"/></template>
    </component>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  props: {
    global: {
      type: Boolean,
      default: false
    },
    interval: {
      type: Number,
      default: 6
    },
    customIconSrc: {
      type: String,
      default: null
    }
  },
  computed: {
    alertsComponent() {
      return this.global ? "v-globalalerts" : "v-inlinealerts";
    }
  }
};
</script>
